import ErrorLogsContainer from './ErrorLogsContainer';
import ErrorLogsContainerHOC from './ErrorLogsContainerHOC';

export {
  ErrorLogsContainer,
  ErrorLogsContainerHOC
};



// WEBPACK FOOTER //
// ./src/browser/components/error-logs/index.js